module.exports = __webpack_public_path__ + "static/media/empty-state-list-vector.74760c10.svg";